function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-126.027 188.685C-157.578 98.3444 -122.876 5.5222 -93.4623 -85.5362C-60.6637 -187.072 -47.8009 -316.201 50.4822 -357.743C148.678 -399.248 249.978 -318.097 345.696 -271.16C430.751 -229.452 518.962 -189.653 563.627 -106.112C612.123 -15.4055 631.117 94.2706 591.914 189.364C552.985 283.794 459.028 338.185 364.507 376.893C271.773 414.869 169.848 436.416 76.2899 400.519C-18.4795 364.158 -92.5592 284.514 -126.027 188.685Z",
    fill: "#EFF3F6",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0725 533.805C-82.4416 574.596 -109.203 685.347 -101.019 735.624L1059.78 1834.73L2096.31 740.012L1546.46 219.384C1491.35 236.796 1401.12 215.156 1237.87 246.162C1033.81 284.919 1014.32 631.824 715.421 661.971C416.519 692.118 305.715 482.817 90.0725 533.805Z",
    fill: "#EFF3F6",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.02123244d646fea134c8dd8d14343749.svg";
export { ForwardRef as ReactComponent };